import React, {useState} from 'react'

import eyeHidden from '../../Assets/Icons/eyeHidden.svg'
import eye from '../../Assets/Icons/eye.svg'

import './BaseInput.scss'

interface BaseButtonProps {
    title: string
    value: string
    placeholder?: string
    onChange: (val: string) => void
    type?: string
    helpTxt?: string
    className?: string
    errorTxt?: string
}

const BaseInput: React.FC<BaseButtonProps> = ({title, value, placeholder="", onChange, type="text", helpTxt, className="", errorTxt}: BaseButtonProps) => {

    const [inputType, setInputType] = useState<string>(type)

    const changeInputType = () => {
        setInputType(inputType === "password" ? "text" : "password")
    }

    return (
        <div className={className}>
            <div className="baseInput">
                <p className="baseInput--title">{title}</p>
                <input className="baseInput--input" type={inputType} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
                {
                    type === "password" && (
                        <img src={inputType === "password" ? eyeHidden : eye} className="baseInput--eye" onClick={changeInputType} />
                    )
                }
            </div>
            {helpTxt && <p className="helpTxt">{helpTxt}</p>}
            {errorTxt && <p className="errorTxt">{errorTxt}</p>}
        </div>
    )
}

export default BaseInput;
